import { Heading } from 'grommet'
import { useTranslation } from 'next-i18next'

import Layout from 'components/layout/Layout'

export default function PrivateGroupLayout() {
  const { t } = useTranslation()
  return (
    <Layout title={t('pages.group.private-group.title')}>
      <Heading>{t('pages.group.private-group.title')}</Heading>
    </Layout>
  )
}
